// B389 (AI_157) — LEITOR DE NDJSON DA RESPOSTA EM FLUXO do /api/analyze.
// O servidor manda uma linha JSON por evento:
//   {"texto":"..."}  pedaço de texto da análise (acumulado aqui)
//   {"fim":{...}}    a resposta completa (mesmo JSON do caminho sem fluxo)
//   {"erro":"..."}   falha depois de os cabeçalhos terem saído (status já 200)
// Puro (sem I/O) para ser testado: quem lê o ReadableStream alimenta
// `alimentar(pedaco)` e chama `finalizar()` no fim.

export interface LeitorNdjson<T> {
  alimentar: (pedaco: string) => void;
  finalizar: () => void;
  textoAcumulado: () => string;
}

export function criarLeitorNdjson<T>(aoEvento: {
  aoTexto?: (acumulado: string) => void;
  aoFim: (resposta: T) => void;
  aoErro: (mensagem: string) => void;
}): LeitorNdjson<T> {
  let buffer = "";
  let acumulado = "";
  let terminou = false;

  const tratarLinha = (linha: string) => {
    const l = linha.trim();
    if (!l || terminou) return;
    let obj: any;
    try {
      obj = JSON.parse(l);
    } catch {
      return; // linha truncada/ilegível: ignorar, nunca derrubar o fluxo
    }
    if (typeof obj?.texto === "string") {
      acumulado += obj.texto;
      aoEvento.aoTexto?.(acumulado);
    } else if (obj && "fim" in obj) {
      terminou = true;
      aoEvento.aoFim(obj.fim as T);
    } else if (typeof obj?.erro === "string") {
      terminou = true;
      aoEvento.aoErro(obj.erro);
    }
  };

  return {
    alimentar(pedaco: string) {
      buffer += pedaco;
      const linhas = buffer.split("\n");
      buffer = linhas.pop() ?? "";
      linhas.forEach(tratarLinha);
    },
    finalizar() {
      if (buffer) tratarLinha(buffer);
      buffer = "";
      if (!terminou) {
        terminou = true;
        aoEvento.aoErro(
          "O fluxo da análise terminou sem a resposta final (conexão interrompida)."
        );
      }
    },
    textoAcumulado: () => acumulado,
  };
}
